export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 100,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('form_label_platformId') || '平台id',
    field: 'platformId',
    minWidth: 140,
    align: 'center',
  },
  {
    title: that.$l('form_label_platformName') || '平台名称',
    field: 'platformName',
    minWidth: 140,
    align: 'center',
  },
  {
    title: that.$l('form_label_platformType') || '平台类型',
    field: 'v_platformType',
    minWidth: 140,
    align: 'center',
  },
  {
    title: that.$l('form_label_paramsTemplate') || '参数模版',
    field: 'paramsTemplate',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    slots: { default: 'createByName' },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    slots: { default: 'modifyByName' },
  },
]
